import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../../_ePulse/layout/core'
import './Pharmacy/Card.css'
import {useLazyQuery, useQuery} from '@apollo/client'
import {
  GET_SCAN_DASHBOARD_REPORT_COUNT,
  GET_SCAN_REPORT_COUNT,
} from '../../../PharmaModule/GraphQLQueries/querys'
import useApi from '../../../../../hooks/useQuery'
import Card from './Pharmacy/Card'
import {LoadingSpinner} from '../../../../../_ePulse/layout/components/LoadingSpinner'
import Appointments from '../../../ScanCenterModule/pages/products/Appointment/appointments'
import { VisitingHours } from '../../Components/visitingHours'
import { VisitingHoursScanCenter } from '../../Components/scanVisitingHours'
import { AppointmentListWrapper } from '../../../ScanCenterModule/modules/todayAppointment/table-list/main'


const ScanCenterDashboardPage = () => {
  const [count2, setCount2] = useState({
    registeredUser: 0,
    registeredDoctor: 0,
    todayActiveAppointment: 0,
    waitingForResult: 0,
    reportReady: 0,
    closedReport: 0,
    consumerAppointment: 0,
    doctorAppointment: 0,
  })
  const [count, setCount] = useState({
    monthlyTransaction: 0,
    monthlyAppointment: 0,
    monthlyRevenue: 0,
  })
  const [isloading, setLoading] = useState(false)

  const getCurrentMonth = () => {
    const currentDate = new Date()
    const month = currentDate.getMonth()
    const year = currentDate.getFullYear()
    return {month, year}
  }

  const getLast12Months = () => {
    const currentMonth = getCurrentMonth()
    const months = []
    let month = currentMonth.month
    let year = currentMonth.year

    for (let i = 0; i < 12; i++) {
      const label = `${getMonthName(month)} ${year}`
      const value = `${getMonthName(month)} ${year}`
      months.unshift({label, value})
      if (month === 0) {
        month = 11
        year--
      } else {
        month--
      }
    }

    return months
  }

  const getMonthName = (monthIndex = 0) => {
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    return monthNames[monthIndex]
  }
  type MonthMapping = {
    [key: string]: number // Key is a string (month abbreviation), value is a number (month number)
  }
  const months: MonthMapping = {
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12,
  }

  const calendraData = getLast12Months()?.reverse()
  const [value, setValue] = useState(calendraData[0]?.value)
  const monthAbbreviation = months[value?.substring(0, 3)]
  const yearDigits = value?.substring(value?.length - 4)
  const [fetchDashboardCounts, {data: dataa, loading: loading1, error: errors, refetch: refetch1}] =
    useLazyQuery(GET_SCAN_DASHBOARD_REPORT_COUNT, {
      fetchPolicy: 'cache-and-network',
    })

  useEffect(() => {
    setLoading(true)
    fetchDashboardCounts()
  }, [fetchDashboardCounts])

  const {
    data: datalist,
    loading: loading3,
    error: error3,
    refetch: refetch3,
  } = useApi(true, GET_SCAN_REPORT_COUNT, {
    month: monthAbbreviation,
    year: parseInt(value?.substring(value?.length - 4)),
  })

  useEffect(() => {
    setLoading(true)
    if (value) {
      // refetch3()
      if (datalist) {
        setCount(datalist?.getDiagnosisMonthlyCount)
        setLoading(false)
      }
    }
  }, [value, datalist])

  useEffect(() => {
    if (dataa) {
      setCount2(dataa?.getDiagnosisReportCount)
    }
  }, [dataa])


  return (
    <>
      <LoadingSpinner isLoading={isloading} />
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div>
          {/* <p className='heading' style={{paddingLeft: 40}}>
            Dashboard
          </p> */}
        </div>
        <div style={{paddingRight: 41}}>
          <select
            className='form-control'
            value={value}
            onChange={(e: any) => {
              setValue(e.target.value)
            }}
          >
            {calendraData?.map((val) => {
              return <option value={val?.value}>{val?.label}</option>
            })}
          </select>
        </div>
      </div>
      <div className='container'>
        <Card heading='Revenue' count={Number(count?.monthlyRevenue?.toFixed(2))} isScan={true} />
        <Card heading='Active Appointments' count={count2?.todayActiveAppointment} isScan={true} />
        <Card heading='Consumer Appointments' count={count2?.consumerAppointment} isScan={true} />
        <Card heading='Doctor Appointments' count={count2?.doctorAppointment} isScan={true} />
        <Card heading='Report History' count={count2?.closedReport} isScan={true} />
      </div>

      <div className='my-pharma-container'>
        <div className='my-pharma-box'>
          <p className='heading'>My Scan</p>
          <div className='a'>
            <div className='top-left'>
              <p className='head'>Doctors</p>
              <p className='count'>{count2?.registeredDoctor}</p>
            </div>
            <div className='top-right'>
              {' '}
              <p className='head'>Patients</p>
              <p className='count'> {count2?.registeredUser}</p>
            </div>
            <div className='bottom-left'>
              {' '}
              <p className='head'>Waiting For Reports</p>
              <p className='count'> {count2?.waitingForResult}</p>
            </div>
            <div className='bottom-right'>
              <p className='head'>Result Ready</p>
              <p className='count'>{count2?.reportReady}</p>
            </div>
            <div>
              <p className='head'>Monthly Transactions</p>
              <p className='count'>{count?.monthlyTransaction}</p>
            </div>
            <div>
              <p className='head'>Appointments</p>
              <p className='count'>{count?.monthlyAppointment}</p>
            </div>
          </div>
        </div>
        <div className='my-pharma-box'>
          <p className='heading'>Visiting Hours</p>
          {/* <div className='a'> */}
            <VisitingHoursScanCenter />
          {/* </div> */}
        </div>
      </div>

      {/* <Appointments/> */}
      <AppointmentListWrapper/>
    </>
  )
}

const ScanCenterDashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <ScanCenterDashboardPage />
    </>
  )
}

export {ScanCenterDashboardWrapper}
